import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { ShiftService } from '../../../Model/Shift/shift.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { LeaveService } from '../../../Model/Leave/leave.service';
import { NgbModal, NgbTimepickerModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ApprovalMatrixFormFilterComponent } from '../../ApprovalMatrixFormFilter/approval-matrix-form-filter/approval-matrix-form-filter.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-shift-policies-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbTimepickerModule, NgbTooltip, LoaderComponent],
  templateUrl: './shift-policies-form.component.html',
  styleUrl: './shift-policies-form.component.scss'
})
export class ShiftPoliciesFormComponent {
  isDisabled: boolean = false;
  isPageDisabled: boolean = true;
  LastWebESSApplicabilityId = null;
  DeviationoccurMax = 365;
  user = [] as any;
  LeaveTypes = [] as any;
  Applicabilitys = [] as any;
  States = [] as any;
  StatesFilter = [] as any;
  Branchs = [] as any;
  BranchsFilter = [] as any;
  Clients = [] as any;
  ClientsFilter = [] as any;
  Sites = [] as any;
  SitesFilter = [] as any;
  Designations = [] as any;
  DesignationsFilter = [] as any;
  ApplicabilityDatas = [] as any;
  ApplicabilityDatasFilter = [] as any;
  Companys = [] as any;
  CompanysFilter = [] as any;
  Departments = [] as any;
  DepartmentsFilter = [] as any;
  Users = [] as any;
  UsersFilter = [] as any;
  ApprovalSubCategory = [] as any;
  ApprovalSubCategoryFilter = [] as any;
  Grades = [] as any;
  GradesFilter = [] as any;

  ShiftRuleDetail = {
    SelectType: 'insert',
    ESS_ShiftRuleID: 0,
    RuleName: null,
    AttendanceType: null,
    Duration: null as any,
    DurationObj: null as any,
    HalfDayDuration: null as any,
    HalfDayDurationObj: null as any,
    OTApplicable: null,
    OTApplicableIn: null,
    MarkWeekOffAsPresent: null,
    IsMarkWeekoff_PresentApplicable: false,
    MarkWeekoffandPresentBoth: false,
    // GracePeriodFrom: null,
    // GracePeriodTo: null,
    FirstCheckInLate: null as any,
    FirstCheckInLateObj: null as any,
    LastCheckOutEarly: null as any,
    LastCheckOutEarlyObj: null as any,
    GracePeriodForDutyDuration: null as any,
    GracePeriodForDutyDurationObj: null as any,
    // FirstCheckInLateByHour: null,
    // FirstCheckInLateByMinute: null,
    // LastCheckOutEarlyByHour: null,
    // LastCheckOutEarlyByMinute: null,
    Deviation: null,
    IsDeviationOccurMultiplyOf: false as any,
    DeviationMoreThan: null,
    DeviationMoreThanPeriod: 'Month' as any,
    DeviationOccurMultiplyOf: null as any,
    DeviationOccurMultiplyOFPeriod: 'Month' as any,
    LeaveDeductDay: 0,
    LeaveDeductType: null as any,
    LeaveDeductTypeObj: null as any,
    ShiftMargin: null as any,
    HourBeforeShiftStart: null as any,
    HourBeforeShiftStartObj: null as any,
    HourAfterShiftStart: null as any,
    HourAfterShiftStartObj: null as any,
    Insentive: null,
    AttendanceGreaterThan: null,
    AttendanceOccurMultiplyOf: null,
    AttendanceOccurMultiplyOfPeriod: null,
    DefaultRule: false,
    WebESSApplicabilityId: null as any,
    MappedId: null as any,
    EmpType: 'FRONT'
  }

  Filter = {
    BranchID: null,
    ClientID: null,
    SiteID: null,
  }

  constructor(
    private leave: LeaveService,
    private session: SessionService,
    private shift: ShiftService,
    private toast: ToastService,
    private route: ActivatedRoute,
    private approvalMatrix: ApprovalMatrixService,
    private router: Router,
    private combo: ComboService,
    private modalService: NgbModal,
    protected common: CommonService,
    protected tooltip: TooltipService
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.ShiftRuleDetail.ESS_ShiftRuleID = parseInt(params['id']));
  }

  ngOnInit(): void {
    this.LoadEmployeeLeaveCombo();
    if (this.ShiftRuleDetail.ESS_ShiftRuleID > 0) {
      this.ESS_ShiftRuleLoadGet();
    } else {
      this.GetApplicability();
    }
  }

  ngAfterViewInit() {
    this.isPageDisabled = false;
  }

  Validate(form: any) {
    if (form.valid) {
      this.ShiftRuleInsertUpdate();
    }
    else {
      form.submitted = true;
    }
  }

  LoadEmployeeLeaveCombo() {
    this.isDisabled = true;
    this.leave.LoadEmployeeLeaveCombo({ EmpMasterID: this.user.UserId, ComboType: 'LeaveMaster' }).subscribe({
      next: (response) => {
        this.LeaveTypes = response.ComboLoad;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'SR', WebESSApplicabilityMasterID: 0, EmpType: this.ShiftRuleDetail.EmpType }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        if (response.Table.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0) >= 0) {
          this.Applicabilitys.push(response.Table.filter((e: any) => e.WebESSApplicabilityMasterID == 0)[0]);
          this.Applicabilitys.splice(this.Applicabilitys.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0), 1);
        }
        if (this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.ShiftRuleDetail.WebESSApplicabilityId).length == 0) {
          this.ShiftRuleDetail.WebESSApplicabilityId = null;
          this.ApplicabilityDatasFilter = [];
        } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 8 && IsClear) {
          this.ApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ApplicabilityDataFilter(IsFilter = false) {
    // if (this.ShiftRuleDetail.WebESSApplicabilityId != 8 || !IsFilter) {
    //   this.ApplicabilityDatas = [];
    //   this.ApplicabilityDatasFilter = [];
    // }
    if (IsFilter || await this.Confirmation(IsFilter)) {
      if (!IsFilter) {
        this.ApplicabilityDatas = [];
        this.ApplicabilityDatasFilter = [];
        this.ShiftRuleDetail.MappedId = null;
        this.LastWebESSApplicabilityId = this.ShiftRuleDetail.WebESSApplicabilityId;
      } else {
        this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
      }

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      if (this.ShiftRuleDetail.WebESSApplicabilityId == 1) {
        this.ApprovalComboLoad('Company');
      } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 5) {
        this.ApprovalComboLoad('Department');
      } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 6) {
        this.ApprovalComboLoad('Designation');
      } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 7) {
        this.ApprovalComboLoad('User');
      } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 9) {
        this.ApprovalComboLoad('Grade');
      } else {
        if (this.ShiftRuleDetail.WebESSApplicabilityId != 0) {
          this.FilterForm();
        }
      }
    }
  }

  async Confirmation(IsFilter = false): Promise<boolean> {
    if (!IsFilter && this.LastWebESSApplicabilityId != null) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae;
      modalRef.componentInstance.Message2 = this.tooltip.Message.ApplicabiliyChangeMessgae2;
      return modalRef.result.then((result) => {
        if (!result) {
          this.ShiftRuleDetail.WebESSApplicabilityId = this.LastWebESSApplicabilityId;
        }
        return result;
      });
    } else {
      return true;
    }
  }

  ButtonApplicabilityDataFilter(id = 0) {
    if (
      (id == 3 || id == 4 || id == 8) ||
      (id == 0 && (this.ShiftRuleDetail.WebESSApplicabilityId == 3 || this.ShiftRuleDetail.WebESSApplicabilityId == 4 || this.ShiftRuleDetail.WebESSApplicabilityId == 8))) {
      this.ApplicabilityDataFilter(true);
    } else {
      this.toast.show({ message: "Filter only allow for client & site", type: toastTypeEnum.warning });
    }
  }

  ApprovalComboLoad(Combotype: String, Combotype2 = null as any, index = 0) {
    this.isDisabled = true;
    this.combo.ApprovalComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Company') {
          this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));
          this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));

          this.Companys.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.CompanyMasterId,
                ApplicabilityData: element.CompanyName,
                WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Branch') {
          this.Branchs = response.Table;
          this.BranchsFilter = response.Table;

          this.Branchs.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Department') {
          this.Departments = response.Table;
          this.DepartmentsFilter = response.Table;

          this.Departments.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DepartmentMasterID,
                ApplicabilityData: element.DepartmentName,
                WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.DepartmentMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.Table;
          this.DesignationsFilter = response.Table;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DesignationMasterID,
                ApplicabilityData: element.DesignationName,
                WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.DesignationMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Client') {
          this.Clients = response.Table;
          this.ClientsFilter = response.Table;

          this.Clients.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.ClientGroupMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.ClientGroupMasterID,
                  ApplicabilityData: element.ClientGroupName,
                  WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                  IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.ClientGroupMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Site') {
          this.Sites = response.Table;
          this.SitesFilter = response.Table;

          this.Sites.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteName,
                  WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                  IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.SiteMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.ComboLoad;
          this.DesignationsFilter = response.ComboLoad;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == null) {
          this.Users = response.Table;
          this.UsersFilter = response.Table;

          this.Users.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.UserMasterId,
                ApplicabilityData: element.UserName,
                WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.UserMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == 'Employee') {
          response.Table.forEach((element: any) => {
            this.ApprovalSubCategory.push(
              {
                ApprovalSubCategoryID: element.UserMasterId,
                ApprovalSubCategory: element.UserName,
              }
            );
          });
          this.ApprovalSubCategoryFilter[index] = this.ApprovalSubCategory;
        } else if (Combotype == 'Grade') {
          this.Grades = response.Table;
          this.GradesFilter = response.Table;

          this.Grades.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.GradeMasterId,
                ApplicabilityData: element.GradeName,
                WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.GradeMasterId) >= 0 ? true : false : false,
              }
            );
          });
        }
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        this.ShiftRuleDetail.MappedId = null;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FilterForm() {
    const modalRef = this.modalService.open(ApprovalMatrixFormFilterComponent, { size: 'lg' });
    modalRef.componentInstance.Title = this.ShiftRuleDetail.WebESSApplicabilityId == 3 ? 'Client' : this.ShiftRuleDetail.WebESSApplicabilityId == 4 ? 'Site' : this.ShiftRuleDetail.WebESSApplicabilityId == 8 ? 'Employee' : '';
    modalRef.componentInstance.WebESSApplicabilityId = this.ShiftRuleDetail.WebESSApplicabilityId;
    modalRef.componentInstance.EmpType = this.ShiftRuleDetail.EmpType;
    modalRef.componentInstance.ShowFilter = {
      ShowBranch: (this.ShiftRuleDetail.WebESSApplicabilityId == 3 || this.ShiftRuleDetail.WebESSApplicabilityId == 4 || this.ShiftRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowClient: (this.ShiftRuleDetail.WebESSApplicabilityId == 4 || this.ShiftRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSite: (this.ShiftRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSearchEmployee: (this.ShiftRuleDetail.WebESSApplicabilityId == 8 || this.ShiftRuleDetail.WebESSApplicabilityId == 4) ? true : false
    }
    modalRef.result.then(result => {
      this.Filter.BranchID = result.BranchID;
      this.Filter.ClientID = result.ClientID;
      this.Filter.SiteID = result.SiteID;
      if (this.ShiftRuleDetail.WebESSApplicabilityId == 1) {
        //this.ApprovalComboLoad('Company');
      } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 3) {
        this.ApprovalComboLoad('Client');
      } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 4) {
        if (result.length >= 0) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteCode + '-' + element.SiteName,
                  WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                  IsCheck: true,
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else {
          this.ApprovalComboLoad('Site');
        }
      } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 5) {
        //this.ComboLoad('Department');
      } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 6) {
        //this.ComboLoad('Designation');
      } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 7) {
        //this.ComboLoad('User');
      } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 8) {
        if (result != undefined) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.EmpMasterID,
                  ApplicabilityData: element.FullName,
                  WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        }
      }
    });
  }

  ESS_ShiftRuleLoadGet() {
    this.isDisabled = true;
    this.shift.ESS_ShiftRuleLoadGet({ SelectType: 1, ESS_ShiftRuleID: this.ShiftRuleDetail.ESS_ShiftRuleID }).subscribe({
      next: (response) => {
        if (response.Table[0].EmpType == null || response.Table[0].EmpType == '') {
          response.Table[0].EmpType = 'FRONT';
        } else {
          response.Table[0].EmpType = response.Table[0].EmpType.toUpperCase();
        }
        this.ShiftRuleDetail = response.Table[0];
        this.ShiftRuleDetail.LeaveDeductTypeObj = [];

        if (this.ShiftRuleDetail.LeaveDeductType != null) {
          this.ShiftRuleDetail.LeaveDeductType.split(',').forEach((element: any) => {
            this.ShiftRuleDetail.LeaveDeductTypeObj.push(parseInt(element));
          });
        }

        this.ShiftRuleDetail.MappedId = response.Table2.map((e: any) => e.MappedId).toString();
        this.ShiftRuleDetail.SelectType = 'update';
        this.LastWebESSApplicabilityId = this.ShiftRuleDetail.WebESSApplicabilityId;

        if (this.ShiftRuleDetail.Duration != null && this.ShiftRuleDetail.Duration != "") {
          this.ShiftRuleDetail.DurationObj = { hour: parseInt(this.ShiftRuleDetail.Duration.split(':')[0]), minute: parseInt(this.ShiftRuleDetail.Duration.split(':')[1]) };
        }

        if (this.ShiftRuleDetail.HalfDayDuration != null && this.ShiftRuleDetail.HalfDayDuration != "") {
          this.ShiftRuleDetail.HalfDayDurationObj = { hour: parseInt(this.ShiftRuleDetail.HalfDayDuration.split(':')[0]), minute: parseInt(this.ShiftRuleDetail.HalfDayDuration.split(':')[1]) };
        }

        if (this.ShiftRuleDetail.FirstCheckInLate != null && this.ShiftRuleDetail.FirstCheckInLate != "") {
          this.ShiftRuleDetail.FirstCheckInLateObj = { hour: parseInt(this.ShiftRuleDetail.FirstCheckInLate.split(':')[0]), minute: parseInt(this.ShiftRuleDetail.FirstCheckInLate.split(':')[1]) };
        }

        if (this.ShiftRuleDetail.LastCheckOutEarly != null && this.ShiftRuleDetail.LastCheckOutEarly != "") {
          this.ShiftRuleDetail.LastCheckOutEarlyObj = { hour: parseInt(this.ShiftRuleDetail.LastCheckOutEarly.split(':')[0]), minute: parseInt(this.ShiftRuleDetail.LastCheckOutEarly.split(':')[1]) };
        }

        if (this.ShiftRuleDetail.GracePeriodForDutyDuration != null && this.ShiftRuleDetail.GracePeriodForDutyDuration != "") {
          this.ShiftRuleDetail.GracePeriodForDutyDurationObj = { hour: parseInt(this.ShiftRuleDetail.GracePeriodForDutyDuration.split(':')[0]), minute: parseInt(this.ShiftRuleDetail.GracePeriodForDutyDuration.split(':')[1]) };
        }

        if (this.ShiftRuleDetail.HourBeforeShiftStart != null && this.ShiftRuleDetail.HourBeforeShiftStart != "") {
          this.ShiftRuleDetail.HourBeforeShiftStartObj = { hour: parseInt(this.ShiftRuleDetail.HourBeforeShiftStart.split(':')[0]), minute: parseInt(this.ShiftRuleDetail.HourBeforeShiftStart.split(':')[1]) };
        }

        if (this.ShiftRuleDetail.HourAfterShiftStart != null && this.ShiftRuleDetail.HourAfterShiftStart != "") {
          this.ShiftRuleDetail.HourAfterShiftStartObj = { hour: parseInt(this.ShiftRuleDetail.HourAfterShiftStart.split(':')[0]), minute: parseInt(this.ShiftRuleDetail.HourAfterShiftStart.split(':')[1]) };
        }

        if (this.ShiftRuleDetail.IsDeviationOccurMultiplyOf == null || this.ShiftRuleDetail.IsDeviationOccurMultiplyOf == '') {
          this.ShiftRuleDetail.IsDeviationOccurMultiplyOf = false;
        }

        if (this.ShiftRuleDetail.DeviationMoreThanPeriod == null || this.ShiftRuleDetail.DeviationMoreThanPeriod == '') {
          this.ShiftRuleDetail.DeviationMoreThanPeriod = 'Month';
        }

        if (this.ShiftRuleDetail.DeviationOccurMultiplyOFPeriod == null || this.ShiftRuleDetail.DeviationOccurMultiplyOFPeriod == '') {
          this.ShiftRuleDetail.DeviationOccurMultiplyOFPeriod = 'Month';
        }


        if (this.ShiftRuleDetail.WebESSApplicabilityId == 1) {
          this.ApprovalComboLoad('Company');
        } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 2) {
          this.ApprovalComboLoad('Branch');
        } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 3) {
          //this.ApprovalComboLoad('Client');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 4) {
          //this.ApprovalComboLoad('Site');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 5) {
          this.ApprovalComboLoad('Department');
        } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 6) {
          this.ApprovalComboLoad('Designation');
        } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 7) {
          this.ApprovalComboLoad('User');
        } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 8) {
          // response.Table2.map((e: any) => e.MappedId).forEach((element: any) => {
          //   this.ComboLoad('EmpLoadOnId', element);
          // });
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 9) {
          this.ApprovalComboLoad('Grade');
        }
        if (this.ShiftRuleDetail.WebESSApplicabilityId == 8) {
          this.GetApplicability(false);
        } else {
          this.GetApplicability();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ShiftRuleInsertUpdate() {
    await this.common.getPageRights();
    this.SearchDropdown('', 'Applicability');
    if (this.ShiftRuleDetail.AttendanceType == null) {
      this.toast.show({ message: 'Please select attendance type', type: toastTypeEnum.warning });
    } else if (this.ShiftRuleDetail.OTApplicable && this.ShiftRuleDetail.OTApplicableIn == null) {
      this.toast.show({ message: 'Please select ot applicable', type: toastTypeEnum.warning });
    } else if (this.ShiftRuleDetail.Deviation && this.common.parseFloat(this.ShiftRuleDetail.DeviationOccurMultiplyOf) > this.common.PeriodTypes.filter(e => e.Value == this.ShiftRuleDetail.DeviationOccurMultiplyOFPeriod)[0].MaxDay) {
      this.toast.show({ message: 'Deviation occur on mulitiple of maximum ' + this.common.PeriodTypes.filter(e => e.Value == this.ShiftRuleDetail.DeviationOccurMultiplyOFPeriod)[0].MaxDay + ' days', type: toastTypeEnum.warning });
    }
    // else if (this.common.parseFloat(this.ShiftRuleDetail.LeaveDeductDay) > 365) {
    //   this.toast.show({ message: 'Deduct day maximum 365', type: toastTypeEnum.warning });
    // } 
    else if (this.ShiftRuleDetail.EmpType != 'FRONT' && this.ShiftRuleDetail.EmpType != 'BACK') {
      this.toast.show({ message: 'Please select applicable for', type: toastTypeEnum.warning });
    } else if (this.ShiftRuleDetail.WebESSApplicabilityId == null) {
      this.toast.show({ message: 'Please select applicability', type: toastTypeEnum.warning });
    } else if (this.ShiftRuleDetail.WebESSApplicabilityId > 0 && this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck).length == 0) {
      this.toast.show({ message: 'Please select sub applicability', type: toastTypeEnum.warning });
    } else if (this.ShiftRuleDetail.WebESSApplicabilityId == 0 && this.ShiftRuleDetail.DefaultRule) {
      this.toast.show({ message: "Applicability none not allow for default rule yes", type: toastTypeEnum.warning });
    } else {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to save?';
      modalRef.result.then(result => {
        if ((this.common.PageRight.IsAdd && this.ShiftRuleDetail.ESS_ShiftRuleID == 0) || (this.common.PageRight.IsEdit && this.ShiftRuleDetail.ESS_ShiftRuleID > 0)) {
          if (result) {
            this.isDisabled = true;
            this.ChangeLeaveDeductDay();
            this.ShiftRuleDetail.MappedId = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck && e.WebESSApplicabilityId == this.ShiftRuleDetail.WebESSApplicabilityId).map((e: any) => e.ApplicabilityDataID).toString();

            if (this.ShiftRuleDetail.AttendanceType == 'hour') {
              this.ShiftRuleDetail.FirstCheckInLate = null;
              this.ShiftRuleDetail.LastCheckOutEarly = null;
            }

            if (!this.ShiftRuleDetail.OTApplicable || this.ShiftRuleDetail.OTApplicable == null) {
              this.ShiftRuleDetail.OTApplicableIn = null;
            }

            if (!this.ShiftRuleDetail.Deviation || this.ShiftRuleDetail.Deviation == null) {
              this.ShiftRuleDetail.IsDeviationOccurMultiplyOf = null;
              this.ShiftRuleDetail.DeviationMoreThan = null;
              this.ShiftRuleDetail.DeviationMoreThanPeriod = null;
              this.ShiftRuleDetail.DeviationOccurMultiplyOf = null;
              this.ShiftRuleDetail.DeviationOccurMultiplyOFPeriod = null;
              this.ShiftRuleDetail.LeaveDeductDay = 0;
              this.ShiftRuleDetail.LeaveDeductType = null;
              this.ShiftRuleDetail.LeaveDeductTypeObj = null;
            } else {
              if (this.ShiftRuleDetail.IsDeviationOccurMultiplyOf) {
                this.ShiftRuleDetail.DeviationMoreThan = null;
              } else {
                this.ShiftRuleDetail.DeviationOccurMultiplyOf = null;
              }
              this.ShiftRuleDetail.LeaveDeductType = this.ShiftRuleDetail.LeaveDeductTypeObj.toString();
            }

            if (!this.ShiftRuleDetail.ShiftMargin || this.ShiftRuleDetail.ShiftMargin == null) {
              this.ShiftRuleDetail.HourBeforeShiftStart = null;
              this.ShiftRuleDetail.HourAfterShiftStart = null;
            }

            if (!this.ShiftRuleDetail.Insentive || this.ShiftRuleDetail.Insentive == null) {
              this.ShiftRuleDetail.AttendanceGreaterThan = null;
              this.ShiftRuleDetail.AttendanceOccurMultiplyOf = null;
              this.ShiftRuleDetail.AttendanceOccurMultiplyOfPeriod = null;
            }

            if (this.ShiftRuleDetail.DurationObj != null) {
              this.ShiftRuleDetail.Duration = this.ShiftRuleDetail.DurationObj.hour + ':' + this.ShiftRuleDetail.DurationObj.minute;
            }

            if (this.ShiftRuleDetail.HalfDayDurationObj != null) {
              this.ShiftRuleDetail.HalfDayDuration = this.ShiftRuleDetail.HalfDayDurationObj.hour + ':' + this.ShiftRuleDetail.HalfDayDurationObj.minute;
            }

            if (this.ShiftRuleDetail.FirstCheckInLateObj != null) {
              this.ShiftRuleDetail.FirstCheckInLate = this.ShiftRuleDetail.FirstCheckInLateObj.hour + ':' + this.ShiftRuleDetail.FirstCheckInLateObj.minute;
            }

            if (this.ShiftRuleDetail.LastCheckOutEarlyObj != null) {
              this.ShiftRuleDetail.LastCheckOutEarly = this.ShiftRuleDetail.LastCheckOutEarlyObj.hour + ':' + this.ShiftRuleDetail.LastCheckOutEarlyObj.minute;
            }

            if (this.ShiftRuleDetail.HourBeforeShiftStartObj != null) {
              this.ShiftRuleDetail.HourBeforeShiftStart = this.ShiftRuleDetail.HourBeforeShiftStartObj.hour + ':' + this.ShiftRuleDetail.HourBeforeShiftStartObj.minute;
            }

            if (this.ShiftRuleDetail.GracePeriodForDutyDurationObj != null) {
              this.ShiftRuleDetail.GracePeriodForDutyDuration = this.ShiftRuleDetail.GracePeriodForDutyDurationObj.hour + ':' + this.ShiftRuleDetail.GracePeriodForDutyDurationObj.minute;
            }

            if (this.ShiftRuleDetail.HourAfterShiftStartObj != null) {
              this.ShiftRuleDetail.HourAfterShiftStart = this.ShiftRuleDetail.HourAfterShiftStartObj.hour + ':' + this.ShiftRuleDetail.HourAfterShiftStartObj.minute;
            }

            this.shift.ShiftRuleInsertUpdate(this.ShiftRuleDetail).subscribe({
              next: (response) => {
                console.log(response);
                if (response.Error_Code == "01") {
                  this.close();
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                } else {
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      });
    }
  }

  ApplicabilityCheckAll(event: any) {
    this.ApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }

  SearchDropdown(SearchValue: string, Label: string) {
    if (Label == 'Applicability') {
      this.ApplicabilityDatasFilter = this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityData.toLowerCase().includes(SearchValue.toLowerCase()));
    }
  }

  ComboLoad(Combotype: String, id: number) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'EmpMasterID': id, 'EmpType': this.ShiftRuleDetail.EmpType, }).subscribe({
      next: (response) => {
        if (Combotype == 'EmpLoadOnId') {
          if (response.ComboLoad.length > 0) {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == response.ComboLoad[0].EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: response.ComboLoad[0].EmpMasterID,
                  ApplicabilityData: response.ComboLoad[0].FullName,
                  WebESSApplicabilityId: this.ShiftRuleDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          }

        }
        this.isDisabled = false;
      },
      complete: () => {

      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SetMaxDay() {
    if (this.ShiftRuleDetail.DeviationOccurMultiplyOFPeriod != null && this.ShiftRuleDetail.DeviationOccurMultiplyOFPeriod != '') {
      this.DeviationoccurMax = this.common.PeriodTypes.filter(e => e.Value == this.ShiftRuleDetail.DeviationOccurMultiplyOFPeriod)[0].MaxDay;
    } else {
      this.DeviationoccurMax = 365;
    }

  }

  timeFormate(event: any, type: String) {
    if (type == 'Duration') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.ShiftRuleDetail.DurationObj.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.ShiftRuleDetail.DurationObj.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    } else if (type == 'HalfDayDuration') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.ShiftRuleDetail.HalfDayDurationObj.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.ShiftRuleDetail.HalfDayDurationObj.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    }
  }

  AttendanceTypeChange() {
    if (this.ShiftRuleDetail.AttendanceType == 'hour') {
      this.ShiftRuleDetail.ShiftMargin = false;
    }
  }

  ChangeLeaveDeductDay() {
    if (this.ShiftRuleDetail.LeaveDeductDay == 0) {
      this.ShiftRuleDetail.LeaveDeductTypeObj = null
    }
  }

  OrderByApplicability() {
    return this.ApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }

  close() {
    this.router.navigate(['/setting/shiftpolicies/']);
  }

  MarkWeekoffand(type: string, event: any) {
    if(event.target.checked){
      if(type == 'B'){
        this.ShiftRuleDetail.IsMarkWeekoff_PresentApplicable = false;
      }else if(type == 'P'){
        this.ShiftRuleDetail.MarkWeekoffandPresentBoth = false;
      }
    }
    
  }
}
